// Import controller interfaces
import { IEligibilityMessagePriorityController } from '../Interfaces/ControllerInterfacesBarrel';
// Import api base controller.
import ApiController from './ApiController';
// Import api models.
import {
    EligibilityMessagePriority,
    EligibilityMessagePriorityAddRequest,
    EligibilityMessagePriorityWithId,
    ErrorMessage,
} from '@app/models/api';

export default class ProductionEligibilityMessagePriorityController extends ApiController implements IEligibilityMessagePriorityController {
    private readonly controllerUrl: string = 'v2/admin/eligibilitymessagepriority';

    public constructor() {
        super();
    }

    public async addEligibilityMessagePriority(
        elgibilityMessagePriorityAddRequest: EligibilityMessagePriorityAddRequest
    ): Promise<EligibilityMessagePriorityWithId> {
        const url: string = `${this.controllerUrl}`;
        const data = elgibilityMessagePriorityAddRequest;

        try {
            const response: Response = await super.makePostCall(url, data);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = 'ERROR: could not save the Eligibility Message Priority.';
            }
            throw error;
        }
    }

    public async updateEligibilityMessagePriority(
        eligibilityMessagePriorityId: string,
        eligibilityMessagePriority: EligibilityMessagePriority
    ): Promise<EligibilityMessagePriorityWithId> {
        const url: string = `${this.controllerUrl}/${eligibilityMessagePriorityId}`;
        const data = eligibilityMessagePriority;

        try {
            const response: Response = await super.makePutCall(url, data);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = `ERROR: could not update the Eligibility Message Priority with ID number: ${eligibilityMessagePriorityId}`;
            }
            throw error;
        }
    }

    public async deleteEligibilityMessagePriority(eligibilityMessagePriorityId: string): Promise<void> {
        const url: string = `${this.controllerUrl}/${eligibilityMessagePriorityId}`;

        try {
            await super.makeDeleteCall(url);
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = `ERROR: could not delete the Eligibility Message Priority with ID number: ${eligibilityMessagePriorityId}`;
            }
            throw error;
        }
    }

    public async getEligibilityMessagePriorities(): Promise<EligibilityMessagePriorityWithId[]> {
        const url: string = `${this.controllerUrl}/getall`;
        try {
            const response: Response = await super.makeGetCall(url);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = 'ERROR: could not get the Eligibility Message Priorities.';
            }
            throw error;
        }
    }
}
